var _style, _circle, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "134px",
    height: "134px",
    viewBox: "0 0 134 134",
    style: {
      enableBackground: "new 0 0 134 134"
    },
    xmlSpace: "preserve",
    className: "ng-hide",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0 {fill:#D2D2D2;} .st1 {opacity:0.2;} .st2 {fill:#0C0D0D;} .st3 {fill:#666E6E;}")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 67,
    cy: 67,
    r: 65
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67,2c35.8411255,0,65,29.1589355,65,65c0,35.8411255-29.1588745,65-65,65S2,102.8411255,2,67         C2,31.1589355,31.1588745,2,67,2 M67,1C30.5491943,1,1,30.5491943,1,67s29.5491943,66,66,66s66-29.5491943,66-66         S103.4508057,1,67,1L67,1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65.9205093,66.3407974h2.1591034C82.8824081,66.7612,99.0083084,72.4024048,97.3628082,86.689003         l-1.6180954,13.3218002c-0.8432999,6.8143997-5.2075043,7.8275986-13.9722061,7.8651962H52.2310143         c-8.7646027-0.0375977-13.1309052-1.0507965-13.9736023-7.8651962L36.6368103,86.689003         C34.9942093,72.4024048,51.1202087,66.7612,65.9205093,66.3407974z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.4317093,43.9341011c0-9.8189011,7.9892006-17.8101006,17.8076019-17.8101006         c9.8218002,0,17.8096008,7.9911995,17.8096008,17.8101006c0,9.8188019-7.9878006,17.8070984-17.8096008,17.8070984         C57.4209099,61.7411995,49.4317093,53.752903,49.4317093,43.9341011z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default-avatar.85a70ee9adeea4bdaeaa4d63dd20f435.svg";
export { ForwardRef as ReactComponent };